import { isString as _isString } from 'lodash';

import { ApiError } from '../models';

const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export const getErrorCodeMessage = (error: ApiError | string): string => {
  if (_isString(error)) {
    return error;
  }

  switch (error.code) {
    case '02009':
      return 'Something went wrong. Please refresh your browser.';
    case '07006':
      return 'Unable to load dashboards. Please contact your administrator.';
    default:
      return error.message ?? GENERIC_ERROR_MESSAGE;
  }
};
